import ToolFrameBase from './ToolFrameBase';
import Shortcut from '../utils/Shortcut';
import { type IToolActionInput, type IToolEnabledInput } from './Tool';

class ToolFrameNext extends ToolFrameBase {
  static toolName = 'Next frame';
  static shortcut = new Shortcut('>,Shift+.,Cmd+Shift+.');

  static action({ controller }: IToolActionInput) {
    const frame = this.findNextOrPreviousFrame(controller.canvas, 'next');
    this.zoomToFrame(frame, controller);
  }

  static enabled({ controller }: IToolEnabledInput) {
    return !!controller.hasFrames();
  }
}

export default ToolFrameNext;
